import React, {Component} from 'react';

const Matches = props => {
  return <div>{props.matches.map(m=>m._id)}</div>;
  // return <MatchesList {...props}/>
};



import {initializer, selectors} from 'utils/resourcerizer';
import {connect} from 'react-redux';

import {MATCHES_NS} from 'constants/index';

const matchesInitializer = initializer(MATCHES_NS)
const matchesSelectors = selectors(MATCHES_NS)

const mstp = (state,ownProps) => ({
  //TODO: refactor with `reselect`
  matches: matchesSelectors.findAll(state, m => m._candidate == ownProps.candidateId)
})

Matches.Container = matchesInitializer(connect(mstp)(Matches))

export default Matches



// WEBPACK FOOTER //
// ./src/components/candidates/Matches.jsx